export enum DermloopConsentTypeEnum {
  Patient = 'patient',
  MedicalUnit = 'medical_unit',
  User = 'user',
}

export const dermloopConsentTypes: DermloopConsentTypeEnum[] = Object.values(
  DermloopConsentTypeEnum,
);
